import { Logger } from 'simple-logging-lib';
import { UNIFIED_NAVIGATION_UI_LOGGER_NAME } from '../constants/logging';
export const errorHandler = (context, options = {}) => cause => {
  const error = new Error(context, {
    cause
  });
  const logger = Logger.getLogger(UNIFIED_NAVIGATION_UI_LOGGER_NAME);
  logger.error(error);
  if (options.rethrow) {
    throw error;
  }
  return 'defaultResult' in options ? options.defaultResult : undefined;
};